<template>
  <div id="ks8303">
    <div id="k1">
      <div>KS8303支付播报音箱</div>
      <label>安全可靠的物联网推送平台，只需简单API调用，即可完成平台间的对接</label>
      <img :src="require('@/assets/pic/ks8303/bg1icon.png')"/>
    </div>
    <div id="k2">
      <label>KS8303是一款二维码收款播报产品，美观大气，品质优越，可灵活搭配码牌。内置大容量可充电电池，WIFI+4G双网通讯。具备语音播报迅捷、音量大，连接稳定不掉线，长时间续航等特点。</label>
    </div>
    <div id="k3">
      <div>WIFI+4G双网通讯</div>
      <label>4G、WIFI双网自动切换，确保通讯的畅顺稳定</label>
    </div>
    <div id="k4">
      <div>大音量语音播报</div>
      <label>独立按键，可循环调节音量大小，最大可达到110dB</label>
    </div>
    <payscene :data="sdata"></payscene>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      sdata: {
        data: [
          {
            pic: require('@/assets/pic/ks8303/s1.png'),
            label: '碰一碰闪付'
          },
          {
            pic: require('@/assets/pic/ks8303/s2.png'),
            label: '小吃店'
          },
          {
            pic: require('@/assets/pic/ks8303/s3.png'),
            label: '菜市场'
          },
        ]
      },
      spdata: {
        file: 'KS8303',
        data: [
          {label: _this.$t('lang.cpu'), desc: ['32位高性能处理器'],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['16MB RAM+16MB ROM'],pic: 'ram.png'},
          {label: '通讯', desc: ['WIFI / 4G / 4G+WIFI'], pic: 'comm.png'},
          {label: _this.$t('lang.speaker'), desc: ['4Ω-3W 频响范围：100Hz-20KHz≥110dB@10cm'], pic: 'speaker.png'},
          {label: '音频格式', desc: ['支持mp3 wav','可选支持arm、pcm'], pic: 'vf.png'},
          {label: _this.$t('lang.button'), desc: ['电源键（开关键）×1、配网键×1','功能键（音量键）×2'], pic: 'keyt.png'},
          {label: '指示灯', desc: ['三色指示灯（红 绿 蓝）'], pic: 'lamp.png'},
          {label: _this.$t('lang.port'), desc: ['Micro USB ×1'], pic: 'port.png'},
          {label: '标签付（选配）', desc: ['NFC标签','支持数字人民币'], pic: 'tpay.png'},
          {label: _this.$t('lang.bettery'), desc: ['锂电池 3.7V/2000mAh','锂电池 3.7V/1800mAh( 可选）','锂电池 3.7V/1200mAh( 可选）'], pic: 'battery.png'},
          {label: '适配器（可选）', desc: ['输入: AC 100~240V','输出: DC 5V/1A'], pic: 'char.png'},
          {label: _this.$t('lang.size'), desc: ['90mm×88.5mm×58mm'], pic: 'size.png'},
          {label: '重量', desc: ['270克（含包装）'], pic: 'weight.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'},
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#ks8303 {
  background: white;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8303/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.49rem;
}
#k1 div {
  margin-top: 2.9rem;
  font-size: .6rem;
  font-weight: bold;
  color: #495B78;
}
#k1 label {
  display: block;
  width: 6.54rem;
  margin-top: .05rem;
  font-size: .3rem;
  font-weight: 400;
  color: #495B78;
}
#k1 img {
  width: 2.95rem;
  margin-top: .45rem;
}
#k2 {
  height: 1.78rem;
  background: #A4A6AA ;
  text-align: center;
}
#k2 label {
  display: inline-block;
  width: 12.18rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .55rem;
  line-height: .48rem;
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8303/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.68rem;
}
#k3 div {
  margin: 2.25rem 0 .2rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: #5E85C2;
}
#k3 label {
  margin-left: .05rem;
  width: 5.4rem;
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #5E85C2;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/ks8303/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 10.1rem;
}
#k4 div {
  margin-top: 2.98rem;
  margin-bottom: .11rem;
  font-size: .6rem;
  font-weight: bold;
  color: #333333
}
#k4 label {
  margin-left: .01rem;
  font-size: .24rem;
  font-weight: 400;
  display: block;
  color: #666666;
}

</style>
